import SplitPageHero from '../common/SplitPageHero'
import { contactHero } from '../../data/contactPageData'

const contactHeroImage = '/assets/contact-hero-bg.png'

function ContactPageHero() {
  const { eyebrow, titleLine1, titleAccent, titleLine2, description, primaryCta, secondaryCta } =
    contactHero

  return (
    <SplitPageHero
      id="contact-page-heading"
      eyebrow={eyebrow}
      title={
        <>
          {titleLine1}
          <span className="split-page-hero__title-accent">{titleAccent}</span>
          <br />
          {titleLine2}
        </>
      }
      description={description}
      image={contactHeroImage}
      imageAlt="Industrial metal warehouse with steel coils and materials"
      primaryCta={primaryCta}
      secondaryCta={secondaryCta}
    />
  )
}

export default ContactPageHero
